import { Grid } from 'antd';

const { useBreakpoint } = Grid;

function useIsDesktop(): boolean {
  return !!useBreakpoint().md;
}

export default useIsDesktop;
